'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _context = require('@prisma-cms/context');

var _context2 = _interopRequireDefault(_context);

var _ui = require('../ui');

var UI = _interopRequireWildcard(_ui);

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var ContextProvider = (_temp = _class = function (_Component) {
  _inherits(ContextProvider, _Component);

  function ContextProvider() {
    _classCallCheck(this, ContextProvider);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  } // componentWillMount() {
  //   const {
  //     query,
  //     ...other
  //   } = this.context;
  //   this.newContext = {
  //     query: {
  //       ...query,
  //       ...this.prepareQuery(),
  //     },
  //     ...other
  //   }
  // }


  ContextProvider.prototype.render = function render() {
    var _this2 = this;

    var children = this.props.children;
    var query = this.context.query; // Object.assign(this.context, {
    //   query: query ? Object.assign(query, {
    //     ...this.prepareQuery(),
    //   }) : query,
    //   // query: {
    //   //   ...query,
    //   //   ...this.prepareQuery(),
    //   // },
    //   ...UI,
    // });

    return _react2.default.createElement(_context2.default.Consumer, null, function (context) {
      var query = context.query;
      return _react2.default.createElement(_context2.default.Provider, {
        value: _extends({}, context, {
          query: _extends({}, query, _this2.prepareQuery())
        }, UI)
      }, children || null);
    });
  };

  ContextProvider.prototype.prepareQuery = function prepareQuery() {
    return _extends({}, this.prepareTemplateQuery());
  }; // prepareUserQuery() {
  //   const {
  //     queryFragments,
  //   } = this.context;
  //   const {
  //     UserNoNestingFragment,
  //     BatchPayloadNoNestingFragment,
  //   } = queryFragments;
  //   const usersConnection = `
  //     query usersConnection (
  //       $where: UserWhereInput
  //       $orderBy: UserOrderByInput
  //       $skip: Int
  //       $after: String
  //       $before: String
  //       $first: Int
  //       $last: Int
  //     ){
  //       objectsConnection: usersConnection (
  //         where: $where
  //         orderBy: $orderBy
  //         skip: $skip
  //         after: $after
  //         before: $before
  //         first: $first
  //         last: $last
  //       ){
  //         aggregate{
  //           count
  //         }
  //         edges{
  //           node{
  //             ...UserNoNesting
  //           }
  //         }
  //       }
  //     }
  //     ${UserNoNestingFragment}
  //   `;
  //   const users = `
  //     query users (
  //       $where: UserWhereInput
  //       $orderBy: UserOrderByInput
  //       $skip: Int
  //       $after: String
  //       $before: String
  //       $first: Int
  //       $last: Int
  //     ){
  //       objects: users (
  //         where: $where
  //         orderBy: $orderBy
  //         skip: $skip
  //         after: $after
  //         before: $before
  //         first: $first
  //         last: $last
  //       ){
  //         ...UserNoNesting
  //       }
  //     }
  //     ${UserNoNestingFragment}
  //   `;
  //   const user = `
  //     query user (
  //       $where: UserWhereUniqueInput!
  //     ){
  //       object: user (
  //         where: $where
  //       ){
  //         ...UserNoNesting
  //       }
  //     }
  //     ${UserNoNestingFragment}
  //   `;
  //   const createUserProcessor = `
  //     mutation createUserProcessor(
  //       $data: UserCreateInput!
  //     ) {
  //       response: createUserProcessor(
  //         data: $data
  //       ){
  //         success
  //         message
  //         errors{
  //           key
  //           message
  //         }
  //         data{
  //           ...UserNoNesting
  //         }
  //       }
  //     }
  //     ${UserNoNestingFragment}
  //   `;
  //   const updateUserProcessor = `
  //     mutation updateUserProcessor(
  //       $data: UserUpdateInput!
  //       $where: UserWhereUniqueInput!
  //     ) {
  //       response: updateUserProcessor(
  //         data: $data
  //         where: $where
  //       ){
  //         success
  //         message
  //         errors{
  //           key
  //           message
  //         }
  //         data{
  //           ...UserNoNesting
  //         }
  //       }
  //     }
  //     ${UserNoNestingFragment}
  //   `;
  //   const deleteUser = `
  //     mutation deleteUser (
  //       $where: UserWhereUniqueInput!
  //     ){
  //       deleteUser(
  //         where: $where
  //       ){
  //         ...UserNoNesting
  //       }
  //     }
  //     ${UserNoNestingFragment}
  //   `;
  //   const deleteManyUsers = `
  //     mutation deleteManyUsers (
  //       $where: UserWhereInput
  //     ){
  //       deleteManyUsers(
  //         where: $where
  //       ){
  //         ...BatchPayloadNoNesting
  //       }
  //     }
  //     ${BatchPayloadNoNestingFragment}
  //   `;
  //   return {
  //     usersConnection,
  //     users,
  //     user,
  //     createUserProcessor,
  //     updateUserProcessor,
  //     deleteUser,
  //     deleteManyUsers,
  //   }
  // }


  ContextProvider.prototype.prepareTemplateQuery = function prepareTemplateQuery() {
    var TemplateNoNestingFragment = 'fragment TemplateNoNesting on Template {\n      id\n      createdAt\n      updatedAt\n      externalKey\n      name\n      description\n      component\n      props\n      components\n      rank\n      vars\n    }\n    ';
    var UserNoNestingFragment = 'fragment UserNoNesting on User {\n      id\n      username\n      email\n      phone\n      fullname\n      image\n      address\n    }\n    ';
    var ProjectNoNestingFragment = 'fragment ProjectNoNesting on Project {\n      id\n      createdAt\n      updatedAt\n      name\n      description\n      url\n      domain\n    }\n    ';
    var TemplateFragment = '\n      fragment Template on Template {\n        ...TemplateNoNesting\n        CreatedBy{\n          ...UserNoNesting\n        }\n        PrismaProject {\n          ...ProjectNoNesting\n        }\n      }\n\n      ' + TemplateNoNestingFragment + '\n      ' + UserNoNestingFragment + '\n      ' + ProjectNoNestingFragment + '\n    ';
    var templatesConnection = '\n      query templatesConnection (\n        $where: TemplateWhereInput\n        $orderBy: TemplateOrderByInput\n        $skip: Int\n        $after: String\n        $before: String\n        $first: Int\n        $last: Int\n      ){\n        objectsConnection: templatesConnection (\n          where: $where\n          orderBy: $orderBy\n          skip: $skip\n          after: $after\n          before: $before\n          first: $first\n          last: $last\n        ){\n          aggregate{\n            count\n          }\n          edges{\n            node{\n              ...Template\n            }\n          }\n        }\n      }\n\n      ' + TemplateFragment + '\n    ';
    var templates = '\n      query templates (\n        $where: TemplateWhereInput\n        $orderBy: TemplateOrderByInput\n        $skip: Int\n        $after: String\n        $before: String\n        $first: Int\n        $last: Int\n      ){\n        objects: templates (\n          where: $where\n          orderBy: $orderBy\n          skip: $skip\n          after: $after\n          before: $before\n          first: $first\n          last: $last\n        ){\n          ...Template\n        }\n      }\n\n      ' + TemplateFragment + '\n    ';
    var template = '\n      query template (\n        $where: TemplateWhereUniqueInput!\n      ){\n        object: template (\n          where: $where\n        ){\n          ...Template\n        }\n      }\n\n      ' + TemplateFragment + '\n    ';
    var createTemplateProcessor = '\n      mutation createTemplateProcessor(\n        $data: TemplateCreateInput!\n      ) {\n        response: createTemplateProcessor(\n          data: $data\n        ){\n          success\n          message\n          errors{\n            key\n            message\n          }\n          data{\n            ...Template\n          }\n        }\n      }\n\n      ' + TemplateFragment + '\n    ';
    var updateTemplateProcessor = '\n      mutation updateTemplateProcessor(\n        $data: TemplateUpdateInput!\n        $where: TemplateWhereUniqueInput!\n      ) {\n        response: updateTemplateProcessor(\n          data: $data\n          where: $where\n        ){\n          success\n          message\n          errors{\n            key\n            message\n          }\n          data{\n            ...Template\n          }\n        }\n      }\n\n      ' + TemplateFragment + '\n    ';
    var deleteTemplate = '\n      mutation deleteTemplate (\n        $where: TemplateWhereUniqueInput!\n      ){\n        deleteTemplate(\n          where: $where\n        ){\n          ...TemplateNoNesting\n        }\n      }\n      ' + TemplateNoNestingFragment + '\n    ';
    var deleteManyTemplates = '\n      mutation deleteManyTemplates (\n        $where: TemplateWhereInput\n      ){\n        deleteManyTemplates(\n          where: $where\n        ){\n          count\n        }\n      }\n    ';
    return {
      templatesConnection: templatesConnection,
      templates: templates,
      template: template,
      createTemplateProcessor: createTemplateProcessor,
      updateTemplateProcessor: updateTemplateProcessor,
      deleteTemplate: deleteTemplate,
      deleteManyTemplates: deleteManyTemplates
    };
  };

  return ContextProvider;
}(_react.Component), _class.contextType = _context2.default, _temp);
exports.default = ContextProvider;
module.exports = exports['default'];